<template>
    <div 
        :class="{'card' : !$breakpoint.smAndDown}"
    >
        <div class="table-container"
            :class="{'px-3' : $breakpoint.xsOnly}"
        >
            <div class="row py-3 mx-0">
                <div class="col-md-12">
                    <h5 class="text-left">
                        <i class="fas fa-inbox mr-2"></i>Counter Offers: {{negotiationSelected.fuel_id | fueltype}}
                    </h5>
                </div>
            </div>  
            <div v-if="!negotiationSelected.counterOffers || negotiationSelected.counterOffers.length < 1" 
                class="w-100 alert alert-secondary mt-3 text-center">
                <i class="fas fa-info-circle mr-2"></i>
                <span v-if="negotiationSelected.status_id == 'ACTIVE' && new Date() > new Date(negotiationSelected.expires)">No counter offers found</span>
                <span v-else>Awaiting counter offers...</span>
            </div>
            <table v-else class="table responsive-table">
                <thead v-if="!negotiationSelected.counterOffers || negotiationSelected.counterOffers.length > 0">
                    <tr>
                        <th v-for="(header, index) in tableHeaders[negotiationType]" :key="index">
                            {{header}}
                            <span v-if="index !== tableHeaders[negotiationType].length - 1">
                                <span v-if="header.toLowerCase() === 'user' || 
                                            header.toLowerCase() === 'seller' || 
                                            header.toLowerCase() === 'terminal' || 
                                            header.toLowerCase() === 'measurement' || 
                                            header.toLowerCase() === ''">
                                    <i v-if="activeSortColumn == header.toLowerCase() && activeSortDirection == 'asc'" 
                                        class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == header.toLowerCase() && activeSortDirection == 'asc'}" 
                                        size="lg" @click="sortByColumn(header, 'desc')"></i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn == header.toLowerCase() && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                        size="lg" @click="sortByColumn(header, 'asc')"></i>
                                </span>
                                <span v-else>
                                    <i v-if="activeSortColumn == header.toLowerCase() && activeSortDirection == 'asc'" 
                                        class="fas fa-sort-numeric-down sort-icon" :class="{'selected': activeSortColumn == header.toLowerCase() && activeSortDirection == 'asc'}" 
                                        size="lg" @click="sortByColumn(header, 'desc')"></i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn == header.toLowerCase() && activeSortDirection == 'desc'? ['selected','fa-sort-numeric-up'] : 'fa-sort-numeric-down' " 
                                        size="lg" @click="sortByColumn(header, 'asc')"></i>  
                                </span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(counterOffer, key) in negotiationSelected.counterOffers" :key="key"
                        :class="{'mx-3 w-100' : $breakpoint.mdAndDown && !$breakpoint.xsOnly, 'py-2' : $breakpoint.mdAndDown}"
                        @click="selectTab(key)">
                        <td label="User" v-if="counterOffer.user"><span>{{counterOffer.user.name}}</span></td>
                        <td label="User" v-else><span>N/A</span></td>
                        <td label="Seller" v-if="counterOffer.user"><span>{{counterOffer.user.account.name}}</span></td>
                        <td label="Seller" v-else><span>N/A</span></td>
                        <td label="Time Remaining" class="countdown-cell">
                            <span v-if="offersTimeRemaining[counterOffer._id] > 0 && negotiationSelected.status_id == 'ACTIVE'">
                                <!-- Progress circle to represent time remaining -->
                                <span class="countdown">
                                    <radial-progress-bar class="countdown-progress" :diameter="35" 
                                        :totalSteps="(new Date(counterOffer.expires) - new Date(counterOffer.created))/1000" 
                                        :completedSteps="(new Date(counterOffer.expires) - new Date())/1000" />
                                </span>

                                <!-- Display time remaining as a tooltip -->
                                <span class="countdown-tooltip">
                                    {{(new Date(counterOffer.expires) - new Date())/1000 | countdownshortformat}}
                                </span>
                            </span>
                            <span v-else-if="offersTimeRemaining[counterOffer._id] == undefined && negotiationSelected.status_id == 'ACTIVE'
                              && new Date(counterOffer.expires) > new Date()
                              ">Loading</span>
                            <span v-else class="text-danger">
                                <i class="fas fa-times"></i>
                            </span>
                        </td>
                        <td label="Terminal" v-if="negotiationType == 'SPOT'" :class="{'changed': counterOffer.terminal._id !== negotiationSelected.terminal._id}">
                            <span v-if="counterOffer.terminal">
                                {{counterOffer.terminal.name}}
                            </span>
                            <span v-else>
                                N/A
                            </span>
                        </td>
                        <td label="Vol/L" :class="{'changed': counterOffer.quantity !== negotiationSelected.quantity}">
                            <span>{{counterOffer.quantity | volumeformat}}</span>
                        </td>
                        <td label="Measurement" :class="{'changed': counterOffer.fuel_measurement_id !== negotiationSelected.fuel_measurement_id}">
                            <span>{{counterOffer.fuel_measurement_id | fuelmeasurementtype}}</span>
                        </td>
                        <td label="Payment Terms" v-if="negotiationType == 'SPOT'" :class="{'changed': counterOffer.collectionTime !== negotiationSelected.collectionTime}">
                            <span>{{counterOffer.collectionTime | collectiondaysformat}}</span>
                        </td>
                        <td label="Payment Terms">
                            <span v-if="counterOffer.credit.credit">{{counterOffer.credit.credit.days | creditdaysformat}}</span>
                            <span v-else>N/A</span>
                        </td>
                        <td label="Price" :class="{'changed': negotiationSelected.type_id == 'TRACKING' ? 
                                (counterOffer.price !== negotiationSelected.livePrice) : (counterOffer.price !== negotiationSelected.price)}">
                            <span>{{counterOffer.price | priceformat}}</span>
                        </td>
                        <td label="+/-">
                            <span class="counter-offer" 
                                :class="negotiationSelected.type_id == 'TRACKING' ?
                                    ((negotiationSelected.livePrice - counterOffer.price) > 0 ? 'lower' : ((negotiationSelected.livePrice - counterOffer.price) < 0 ? 'higher' : null)) 
                                    : ((negotiationSelected.price - counterOffer.price) > 0 ? 'lower' : ((negotiationSelected.price - counterOffer.price) < 0 ? 'higher' : null))">
                                {{negotiationSelected.type_id == 'TRACKING' ?
                                    Math.abs(negotiationSelected.livePrice - counterOffer.price) : Math.abs(negotiationSelected.price - counterOffer.price)
                                    | pricedeltaformat}}
                            </span>
                        </td>
                        <td label="Action" class="d-flex align-items-center justify-content-end td-actions">
                            <button v-if="offersTimeRemaining[counterOffer._id] > 0 && negotiationSelected.status_id == 'ACTIVE'" 
                                class="btn btn-primary" @click="acceptCounter(counterOffer._id)">Accept</button>
                            <span v-else class="negotiation-status">
                                <span v-if="negotiationSelected.counterOffers[key].status_id == 'COMPLETED'"
                                    class="static accepted">
                                    Accepted
                                </span>
                                <span v-else-if="offersTimeRemaining[counterOffer._id] == undefined && negotiationSelected.status_id == 'ACTIVE' && 
                                    new Date(counterOffer.expires) > new Date()">Loading</span>
                                <span v-else class="static expired text-center">Expired</span>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data() {
        return {
            tableHeaders: {
                SPOT: ['User', 'Seller', 'Time Remaining', 'Terminal', 'Vol/L', 'Measurement', 'Lifting Period', 
                    'Payment Terms', 'Price', '+/-', 'Action'],
                BUNKERING: ['User', 'Seller', 'Time Remaining', 'Vol/L', 'Measurement',  'Payment Terms', 'Price', 
                    '+/-', 'Action']
            },
            activeSortDirection: 'asc',
            activeSortColumn: 'time remaining',
        }
    },
    computed: {
        ...mapState('negotiation',['negotiationSelected', 'offersTimeRemaining', 'showAcceptCounterOffer']),
        ...mapState('fuelsType', ['fuels']),
        ...mapState('notifications', ['notificationList']),
        negotiationType: {
            get: function(){
                if (Object.keys(this.negotiationSelected).length > 0 && this.fuels.length > 0){
                    let fuel = this.fuels.find(fuel => fuel._id == this.negotiationSelected.fuel_id)
                    return fuel.type
                }
            }
        },
        openAcceptCounterOfferModal: function(){
            if (this.showAcceptCounterOffer){
                let element = this.$root.$refs.acceptCounterOffer.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        }
    },
    watch: {
        openAcceptCounterOfferModal(){}
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB']),
        ...mapActions('negotiation', ['updateShowAcceptCounterOffer', 'setAcceptedCounterId']),
        ...mapActions('conversation',['loadConversation']),
        ...mapActions('notifications', ['updateNotification']),
        selectTab: async function(counterIndex){
            const conversationSelectedId = this.negotiationSelected.counterOffers[counterIndex].conversation_id
            this.loadConversation(conversationSelectedId)

            this.SELECT_TAB(counterIndex + 1)

            /* Smooth scroll horizontally to the selected conversation tab */
            let selectedTab = this.$parent.$refs.conversationTab[counterIndex]
            selectedTab.scrollIntoView({block: 'end', behavior: 'smooth'})

            /* Remove red dot notification if needed */
            const negotiationId = this.negotiationSelected._id
            this.notificationList.forEach(notification => {
                if (notification.type_id === 'NEGOTIATION' && notification.group_id === negotiationId && notification.meta && notification.meta.counterOfferId === this.negotiationSelected.counterOffers[counterIndex]._id)
                    this.updateNotification(negotiationId)
            })
        },
        acceptCounter: function(id){
            this.setAcceptedCounterId(id)
            this.updateShowAcceptCounterOffer(true)
        },
        sortByColumn(columnHeader, direction){
            this.activeSortDirection = direction
            this.activeSortColumn = columnHeader.toLowerCase()
            
            let stringA = ''
            let stringB = ''

            if (this.negotiationSelected.counterOffers && 
                this.negotiationSelected.counterOffers.length > 0){
                switch (this.activeSortColumn){
                    case 'user': // Sort by user name
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            stringA = a.user.name.toLowerCase()
                            stringB = b.user.name.toLowerCase()
                            
                            if (this.activeSortDirection == 'asc'){
                                if (stringA < stringB) {return -1;}
                                if (stringA > stringB) {return 1;}
                                return 0;
                            }
                            else {
                                if (stringA < stringB) {return 1;}
                                if (stringA > stringB) {return -1;}
                                return 0;
                            }
                        })
                    case 'seller': // Sort by seller
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            stringA = a.user.account.name.toLowerCase()
                            stringB = b.user.account.name.toLowerCase()
                            
                            if (this.activeSortDirection == 'asc'){
                                if (stringA < stringB) {return -1;}
                                if (stringA > stringB) {return 1;}
                                return 0;
                            }
                            else {
                                if (stringA < stringB) {return 1;}
                                if (stringA > stringB) {return -1;}
                                return 0;
                            }
                        })
                    case 'terminal': // Sort by terminal
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            stringA = a.terminal.name
                            stringB = b.terminal.name
                            
                            if (this.activeSortDirection == 'asc'){
                                if (stringA < stringB) {return -1;}
                                if (stringA > stringB) {return 1;}
                                return 0;
                            }
                            else {
                                if (stringA < stringB) {return 1;}
                                if (stringA > stringB) {return -1;}
                                return 0;
                            }
                        })
                    case 'time remaining': // Sort by time remaining
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            if (this.activeSortDirection == 'asc'){
                                return new Date(a.expires) - new Date(b.expires)
                            }
                            else {
                                return new Date(b.expires) - new Date(a.expires)
                            }
                        })
                    case 'volume': // Sort by volume
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            if (this.activeSortDirection == 'asc'){
                                return a.quantity - b.quantity
                            }
                            else {
                                return b.quantity - a.quantity
                            }
                        })
                    case 'measurement': // Sort by fuel measurement type
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            stringA = this.$root.$options.filters.fuelmeasurementtype(a.fuel_measurement_id)
                            stringB = this.$root.$options.filters.fuelmeasurementtype(b.fuel_measurement_id)
                            
                            if (this.activeSortDirection == 'asc'){
                                if (stringA < stringB) {return -1;}
                                if (stringA > stringB) {return 1;}
                                return 0;
                            }
                            else {
                                if (stringA < stringB) {return 1;}
                                if (stringA > stringB) {return -1;}
                                return 0;
                            }
                        })
                    case 'lifting period': // Sort by Lifting Period or delivery date
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            const collectiondays_a = a.collectionTime
                            const collectiondays_b = b.collectionTime
    
                            if (this.activeSortDirection == 'asc'){
                                return collectiondays_a - collectiondays_b
                            }
                            else {
                                return collectiondays_b - collectiondays_a
                            }
                        })
                    case 'credit days': // Sort by credit days
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            if (this.activeSortDirection == 'asc'){
                                return a.credit.days - b.credit.days
                            }
                            else {
                                return b.credit.days - a.credit.days
                            }
                        })
                    case 'price': // Sort by price
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            if (this.activeSortDirection == 'asc'){
                                return a.price - b.price
                            }
                            else {
                                return b.price - a.price
                            }
                        })
                    case '+/-': // Sort by price difference
                        return this.negotiationSelected.counterOffers.sort((a, b) => {
                            const delta_a = this.negotiationSelected.type_id == 'FIXED' ?
                                (a.price - this.negotiationSelected.price) : (a.price - this.negotiationSelected.livePrice)
                            const delta_b = this.negotiationSelected.type_id == 'FIXED' ?
                                (b.price - this.negotiationSelected.price) : (b.price - this.negotiationSelected.livePrice)
                            
                            if (this.activeSortDirection == 'asc'){
                                return delta_a - delta_b
                            }
                            else {
                                return delta_b - delta_a
                            }
                        })
                    default:
                        return
                }
            }
        }
    }
}
</script>